import classNames from 'clsx';
import React, { createRef } from 'react';
import { useSelector } from 'react-redux';
import { Route, useParams } from 'react-router';

import Translation from '@swf/components/Translation/Translation';
import { RoutingKey } from '@swf/core/enums';
import { select } from '@swf/core/store';
import { ClubContainer, NoData, useHomeGamesWidget, usePollLobbyData } from '@swf/poker';

import useInviteToClub from '../Invite/useInviteToClub';

import AnimateClubs from './AnimateClubs/AnimateClubs';
import ClubItem from './ClubItem/ClubItem';
import CreateClubButton from './CreateClubButton/CreateClubButton';
import JoinClubButton from './JoinClubButton/JoinClubButton';
import {
  TXTWCL_No_Clubs_to_Show,
  TXTWCL_Your_clubs_will_be_shown_here
} from './MyClubs.messages.json';
import styles from './MyClubs.scss';

const ClubButtons = ({ className }: { className?: string }) => (
  <div className={classNames(styles.buttons, className)}>
    <JoinClubButton loading={false} />
    <CreateClubButton loading={false} />
  </div>
);

const MyClubs: React.FC = () => {
  const { widgetSelect } = useHomeGamesWidget();
  const { routes } = useSelector(select.page.getMeta);
  const clubsPath = routes?.[RoutingKey.HomeGamesClubs] ?? '';
  const clubs = useSelector(widgetSelect.clubs);
  const { clubId, section } = useParams<{ clubId: string; section: string }>();
  const hasClubs = !!clubs.length;

  usePollLobbyData();
  useInviteToClub();

  if (clubId && section) {
    return (
      <Route
        path={clubsPath}
        render={(props) => <ClubContainer {...props} path={clubsPath} loading />}
      />
    );
  }

  return (
    <div className={styles.container}>
      {!hasClubs && (
        <NoData
          className={styles.noData}
          primaryText={<Translation {...TXTWCL_No_Clubs_to_Show} />}
          secondaryText={<Translation {...TXTWCL_Your_clubs_will_be_shown_here} />}
        >
          <ClubButtons className={styles.noDataButtons} />
        </NoData>
      )}
      {hasClubs && (
        <>
          <ClubButtons />
          <div className={styles.clubsContainer}>
            <AnimateClubs>
              {clubs.map((club) => (
                <ClubItem key={club.clubId} ref={createRef()} {...club} />
              ))}
            </AnimateClubs>
          </div>
        </>
      )}
    </div>
  );
};

export default MyClubs;
